import React from "react";
import {ProjectDetailsHero, ProjectSingleDetails, SEO} from "../components";
import {useParams} from "react-router-dom";
import {projects} from "../constants/Projects";
const ProjectDetails = () => {
  const {slug} = useParams();
  const project = projects.find((p) => p.slug === slug);

  if (!project) return <p>Project not found.</p>;
  return (
    <main>
      <SEO
        title={
          project.SEO?.title ||
          "Deep Kapadia | Frontend Project Portfolio | React, Next.js, Figma to Web Expert"
        }
        description={
          project.SEO?.description ||
          "Browse real-world projects crafted by Deep Kapadia — showcasing expertise in React, Next.js, Figma to Code conversions, UI architecture, and performance-focused development."
        }
        keywords={
          project.SEO?.keywords ||
          "Deep Kapadia Portfolio, Frontend Projects, React Project List, Next.js Portfolio, Figma to HTML Work, Web Development Portfolio, UI Development, Modern Frontend Examples, Responsive Design Projects"
        }
        image={project.image || "https://www.deepkapadia.work/images/logo.png"}
        url={`https://www.deepkapadia.work/projects/${project.slug}`}
      />
      <div className="project-details-container">
        <ProjectDetailsHero title={project.title || ""} />
        <ProjectSingleDetails projectDetails={project} />
      </div>
    </main>
  );
};

export default ProjectDetails;
